import { render } from "./notifyMsg.vue?vue&type=template&id=7a4074a1"
import script from "./notifyMsg.vue?vue&type=script&lang=js"
export * from "./notifyMsg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__